
export const PUBLIC_PAGE_PREFIX = "/public/";

export function isPublicPagePath(pathname?: string): boolean {
  const path = pathname ?? window.location.pathname;
  return path.startsWith(PUBLIC_PAGE_PREFIX);
}
